
if (typeof Function.prototype.bind === 'undefined') {
  Function.prototype.bind = function (context) {
    var params = ([]).slice.call(arguments, 1);
    var fn = this;
    return function () {
      var allParams = params.concat(([]).slice.call(arguments, 0));
      return fn.apply(context, allParams);
    };
  };
};
module.exports = function anonymous(locals, escape, include, rethrow
/*``*/) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("\n\n<div class=\"related\">\n    <ul class=\"re-list\">\n        ")
    ;  for (var i=0;i<items.length;i++){
    ; __append("\n        <li class=\"re-item clearfix\"  data-id=\"")
    ; __append(escape(items[i].id))
    ; __append("\" data-from=\"")
    ; __append(escape(items[i].from))
    ; __append("\">\n            <div class=\"re-image fl\">\n                <div >\n                    <img src=\"")
    ; __append(escape(items[i].thumb))
    ; __append("\" alt=\"")
    ; __append(escape(items[i].title))
    ; __append("\">\n                </div>\n\n            </div>\n            <div class=\"re-info fr\">\n                <div class=\"re-detail\">\n                    <p class=\"info\" >\n                        ")
    ; __append(escape(items[i].title))
    ; __append("\n                    </p>\n                    <p class=\"state\">\n                        <span class=\"status ")
    ; if (items[i].statusClass== 'active') {
    ; __append(escape(items[i].statusClass))
    ; }else if(items[i].statusClass == 'end'){
    ; __append("endbox")
    ; }
    ; __append("\">\n                            <span class=\"")
    ; __append(escape(items[i].statusClass))
    ; __append("\">\n                                ")
    ; __append(escape(items[i].status))
    ; __append("\n                            </span>\n                        </span>\n                        <span class=\"time\">")
    ; __append(escape(items[i].date))
    ; __append(" ")
    ; __append(escape(items[i].time))
    ; __append("</span>\n                    </p>\n                </div>\n            </div>\n        </li>\n        ")
    ; }
    ; __append("\n    </ul>\n</div>\n\n\n\n")
  }
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/modules/relatedNews/relatedNews.ejs
// module id = 638
// module chunks = 0